export default "__VITE_ASSET__BeI6LTRm__"